/*
********************************************************************************
File for importing images so that they can be optimized by Vite.  Used in 
damage-map.js and navigation.js.
********************************************************************************
*/

//@ts-nocheck
// Toggle preceding from @ts-nocheck to @ts-check to enable TypeScript checking

/*Import all project images so image references in dynamic HTML can be updated with hashes
NOTE: To get the image update logic working again, images need to be moved from public/img
to src/assets/img, and the import statements from /assets need to be updated to ../../src/assets
to account for the structure of the ionic-shared sym link directory.  Also need to add back hashing
statement in Vite config, and run the npm run img-build script instead of npm run build.  Also
need to uncomment the @img alias to get working again in vite config.
*/

import legendImg from "/assets/img/legend-v2.png";
import car1000 from "/assets/img/car-1000.png";
import car2000 from "/assets/img/car-2000.png";
import carInterior1000 from "/assets/img/car-interior-1000.png";
import logoImg300 from "/assets/img/logo-300-v2.png";
import logoImg900 from "/assets/img/logo-900-v2.png";
import crosshairs from "/assets/img/crosshairs-256.png";
import exclamationCircle from "/assets/img/exclamation-circle-256.png";
import exclamationTriangle from "/assets/img/exclamation-triangle-256.png";
import questionCircle from "/assets/img/question-circle-256.png";
import timesCircle from "/assets/img/times-circle-256.png";
import stainedCircle from "/assets/img/stain-256.png";
import carFront from "/assets/img/car-front.png";
import carBack from "/assets/img/car-back.png";
import carDriverProfile from "/assets/img/car-driver-profile.png";
import carDriverRearProfile from "/assets/img/car-driver-rear-profile.png";
import carDriverSide from "/assets/img/car-driver-side.png";
import carPassengerProfile from "/assets/img/car-passenger-profile.png";
import carPassengerRearProfile from "/assets/img/car-passenger-rear-profile.png";
import carPassengerSide from "/assets/img/car-passenger-side.png";
import carTop from "/assets/img/car-top.png";
import carTrunk from "/assets/img/car-trunk.png";
import carInteriorFront from "/assets/img/car-interior-front.png";
import carInteriorRear from "/assets/img/car-interior-rear.png";
import carOdomometer from "/assets/img/car-odometer.png";
import carVin from "/assets/img/car-vin-label.png";

// Prefix fav icons with base path so will work correctly on Trevor's server
// IMPORTANT: When updating favicon files, you MUST update:
//   1. These file paths below
//   2. The <link> tags in index.html (lines 27-28)
//   3. The actual favicon image files in /public
// NOTE: Firefox aggressively caches favicons. If icons don't update after clearing cache,
//       increment the version number in the filename (e.g., v3 -> v4) to force refresh.
const BASE = import.meta.env.BASE_URL || "/";
const favIconLight16 = `${BASE}favicon-light-16-v3.png`;
const favIconDark16 = `${BASE}favicon-dark-16-v3.png`;
const favIconLight32 = `${BASE}favicon-light-32-v3.png`;
const favIconDark32 = `${BASE}favicon-dark-32-v3.png`;

export { favIconLight16, favIconLight32, favIconDark16, favIconDark32 };

// Make sure app references are using the global app object associated with window
const app = window.app;

// Make images available for import in other modules
// prettier-ignore
export { 
	legendImg, 
	car1000, 
	car2000, 
   carInterior1000,
	logoImg300, 
	logoImg900,
};

export const damageMarkerIcons = {
	crosshairs: crosshairs,
	exclamationCircle: exclamationCircle,
	exclamationTriangle: exclamationTriangle,
	questionCircle: questionCircle,
	timesCircle: timesCircle,
	stainedCircle: stainedCircle,
};

// Convenience dictionary for inspection images photo placeholders
export const carPlaceholders = {
	carFront: carFront,
	carBack: carBack,
	carDriverProfile: carDriverProfile,
	carDriverRearProfile: carDriverRearProfile,
	carDriverSide: carDriverSide,
	carPassengerProfile: carPassengerProfile,
	carPassengerRearProfile: carPassengerRearProfile,
	carPassengerSide: carPassengerSide,
	carTop: carTop,
	carTrunk: carTrunk,
	carInteriorFront: carInteriorFront,
	carInteriorRear: carInteriorRear,
	carOdomometer: carOdomometer,
	carVin: carVin,
};
